var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "_bb-1 _bc--soft _my-2 _mx-1" })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }